export default "__VITE_PUBLIC_ASSET__992b3ea3__"